var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container page"},[_c('div',{staticClass:"header"},[_c('van-nav-bar',{staticClass:"nav-bar",attrs:{"title":_vm.$t('my.online_service')},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('van-icon',{attrs:{"name":"arrow-left","color":"#fff"},on:{"click":function($event){return _vm.back()}}})]},proxy:true}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }